import React, { useState } from 'react';
import { Chip, Grid, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  chip: {
    maxWidth: 200,
  },
  toggleChip: {
    cursor: 'pointer',
  },
  emptyLabel: {
    color: '#9e9e9e',
  },
}));

function ChipsWithMore({ items, maxVisible = 2, emptyLabel = 'No courses' }) {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const courses = (items || []).map(item => `${item}`.trim()).filter(Boolean);
  if (courses.length === 0) {
    return (
      <span className={classes.emptyLabel} data-test="courses-empty">
        {emptyLabel}
      </span>
    );
  }

  const hiddenCount = courses.length - maxVisible;
  const visibleCourses = expanded ? courses : courses.slice(0, maxVisible);

  return (
    <Grid container spacing={1} alignItems="center">
      {visibleCourses.map(course => (
        <Grid key={course} item>
          <Tooltip title={course}>
            <Chip size="small" label={course} className={classes.chip} />
          </Tooltip>
        </Grid>
      ))}
      {hiddenCount > 0 && (
        <Grid item>
          <Chip
            size="small"
            color="primary"
            variant="outlined"
            className={classes.toggleChip}
            label={expanded ? 'Show less' : `+${hiddenCount} more`}
            onClick={() => setExpanded(prev => !prev)}
            data-test="courses-toggle-more"
          />
        </Grid>
      )}
    </Grid>
  );
}

export { ChipsWithMore };
